export default __webpack_public_path__ + "static/media/Icon-ionic-ios-close-circle.14b1e777.svg";